<ng-container *ngIf="kycs?.total">
    &nbsp;<span class="badge badge-pill badge-info">{{ kycs?.total }} kycs</span>
</ng-container>